(function () {
    'use strict';

    angular
        .module('manageFlight')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('manageFlight', {
                sticky:true,
                url: '/manage-flight',
                views:{
                    'manageFlightView':{
                        templateUrl: 'manage-flight/views/manage-flight.tpl.html',
                        controller: 'ManageFlightCtrl',
                        controllerAs: 'manageFlight'
                    }
                }
            });
    }
}());
